import React from 'react';

import { useSelector } from 'react-redux';

import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { useStatsigGate } from 'src/contexts/feature-provider';
import { getPullRequestViewSyncStrategies } from 'src/redux/pull-request/selectors';
import RepositoryBranchSyncInfo, {
  BranchSyncInfoProps,
} from 'src/sections/repository/components/commit-list/branch-sync-info';
import { REPO_EVENT_SOURCES } from 'src/sections/repository/types';
import { SyncStrategy } from 'src/types/pull-request';

import { SyncBranchDialog } from '../../../branches/components/dialogs/sync-branch-dialog-functional';
import { usePullRequestBranchSyncInfoDetails } from '../../hooks/commit-list/pull-request-branch-sync-info';

/** Section message that includes the number of commits behind the base branch and
 * a "Sync now" button if user is able to perform action. Clicking "Sync now" button
 * will open the sync branch dialog or PR conflicts dialog, depending on state.
 */
export function SyncBranchInfo({
  isLoadingConflicts,
}: {
  isLoadingConflicts: boolean;
}): JSX.Element | null {
  const branchSyncInfoDetails: BranchSyncInfoProps =
    usePullRequestBranchSyncInfoDetails();
  const syncStrategies: SyncStrategy[] | undefined = useSelector(
    getPullRequestViewSyncStrategies
  );

  const mergeStatusStateMessageDisabled = useStatsigGate(
    StatsigFeatureKeys.mergeStatusStateMessageDisabled
  );

  if (
    branchSyncInfoDetails &&
    branchSyncInfoDetails.branchSyncInfo &&
    // Sync now button depends on conflicts being loaded in
    !isLoadingConflicts
  ) {
    return (
      <div>
        <RepositoryBranchSyncInfo
          {...branchSyncInfoDetails}
          appearance="section-message"
          context="pr"
          hideBranchSyncButton={mergeStatusStateMessageDisabled}
        />
        <SyncBranchDialog
          syncStrategies={syncStrategies}
          analyticsParentPage={REPO_EVENT_SOURCES.PULL_REQUEST_SCREEN}
        />
      </div>
    );
  }
  return null;
}
